import React, { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Cookies } from '../Cookies'
import { MenuBar } from '../MenuBar'
import MetaTags, { MetaTagsProps } from '../MetaTags'
import { Content } from '../../components/Content'
import { Footer } from '../Footer'
import { NewsletterForm } from '../NewsletterForm'
import { Markdown } from '../Markdown'
import { MenuItem } from '../../lib/strapi/responseTypes'

export type BlogArticleProps = PropsWithChildren<{
  paragraph: string
  children: ReactNode
  menuItems: [MenuItem]
  source: string
  pageTitle: string
  pageRelativeURL?: string
  description?: string
  imageURL?: string
  imageAltText?: string
}> &
  MetaTagsProps

const BlogArticlePage = ({
  children,
  paragraph,
  menuItems,
  source,
  pageTitle,
  pageRelativeURL,
  description,
  imageURL,
  imageAltText,
}: BlogArticleProps) => {
  const { t: translate } = useTranslation()
  return (
    <>
      <MetaTags
        pageTitle={pageTitle}
        pageRelativeURL={pageRelativeURL}
        description={description}
        imageAltText={imageAltText}
        imageURL={imageURL}
      />
      <Cookies />
      <MenuBar currentPage={pageTitle} menuItems={menuItems} />
      <Content>
        <div className="space-y-8 text-center"> {children}</div>
        <div className="flex justify-center">
          <div className="w-5/6">
            <Markdown source={source} isForBlog />
            <div className="mt-14">
              <NewsletterForm
                title={translate('signUpForNewsletter')}
                paragraph={paragraph}
              />
            </div>
          </div>
        </div>
      </Content>
      <Footer />
    </>
  )
}

export default BlogArticlePage
